import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {MenuItem, MenuItemCommandEvent} from 'primeng/api';
import {Popover} from 'primeng/popover';
import {DeviceId, FindingId, VideoRecordingId} from '@webmate-web-core/shared/types/ids';
import {ViewId} from '../../../../../shared/types';
import {VideoRecordingService} from '@webmate-web-core/shared/services/video-recording.service';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {TakeVideoSnippetComponent} from './take-video-snippet.component';

@Component({
    selector: 'wm-console-toolbar-snapshot-action',
    templateUrl: 'console-toolbar-snapshot.component.html',
    styleUrls: ['console-toolbar-snapshot.component.less']
})
export class ConsoleToolbarSnapshotComponent {

    @ViewChild('snapshot') popover: Popover;
    @ViewChild('splitButton', {read: ElementRef}) button: ElementRef;

    @ViewChild(TakeVideoSnippetComponent) videoSnippet?: TakeVideoSnippetComponent;

    @Input() consoleViewId: ViewId;
    @Input() deviceId: DeviceId;
    @Input() isMobile: boolean;

    private recordingOption = {
        label: 'Record Video',
        command: () => {
            this.open('video');
        },
        automationId: 'record-video-btn',
    } as MenuItem;

    private recordingSettingsOption = {
        label: 'Recording Settings',
        command: (event: MenuItemCommandEvent)=> {
            setTimeout(() => {
                this.popover.show(null, this.button.nativeElement);
            });
        }
    } as MenuItem;

    private screenshotOption = {
        label: 'Take Screenshot',
        command: () => {
            this.open('screenshot');
        },
        automationId: 'take-screenshot-btn',
    } as MenuItem;

    buttonOptions: MenuItem[] = [this.recordingOption];

    buttonMode: 'screenshot' | 'video' = 'screenshot';
    recordingActive: boolean = false;

    preselectedFinding: FindingId;

    activeRecordingOnDevice?: VideoRecordingId;

    constructor(private videoService: VideoRecordingService) {
    }

    ngOnInit() {
        if (this.isMobile) {
            // Check if there is an active native recording for this device, and set up the button accordingly
            this.videoService.getVideosForDevice(this.deviceId, 'recording').pipe(catchError(e => {
                return of([]);
            })).subscribe(videos => {
                if (videos.length >= 1) {
                    this.activeRecordingOnDevice = videos[0].id;
                    this.buttonMode = 'video';
                    this.recordingActive = true;
                    this.updateButtonOptions();
                }
            });
        }
    }

    private updateButtonOptions() {
        let options = [];
        if (this.buttonMode === 'video') {
            if (this.recordingActive) {
                options.push(this.recordingSettingsOption);
            }
            options.push(this.screenshotOption);
        } else {
            options.push(this.recordingOption);
        }
        this.buttonOptions = options;
    }

    setRecordingState(state: boolean) {
        this.recordingActive = state;
        this.updateButtonOptions();
    }

    public open(state: 'screenshot' | 'video', findingId?: FindingId) {
        this.preselectedFinding = findingId;
        this.buttonMode = state;
        this.updateButtonOptions();
        setTimeout(() => {
            this.popover.show(null, this.button.nativeElement)
        })
    }

    get buttonLabel() {
        if (this.buttonMode === 'screenshot') {
            return 'Take Screenshot';
        } else {
            return this.recordingActive ? 'Stop Recording' : 'Record Video';
        }
    }

    buttonClicked(event: MouseEvent) {
        if (this.buttonMode === 'screenshot') {
            this.popover.toggle(event, this.button.nativeElement);
        } else if (this.buttonMode === 'video') {
            // TODO still necessary?
            if (this.recordingActive) {
                this.videoSnippet.stopRecording();
                // this.recordingActive = false;
            }
            this.popover.toggle(event, this.button.nativeElement);
        }
    }

}